import classNames from 'classnames';
import React from 'react';
import './ButtonStack.scss';
export function ButtonStack({ children, className }) {
    const classes = classNames('button-stack', { [`${className}`]: className });
    return React.createElement("div", { className: classes }, children);
}
